import React from "react";
import classNames from "classnames";
import { Dialog } from "..";
import { DialogProps } from "../Dialog/Dialog";
import "./ActionBar.scss";

interface Props extends Pick<DialogProps, "isOpen" | "ariaLabel" | "className" | "contentClassName"> {
}

/**
 * Bar that is stuck to the bottom of the page. Built around `Dialog`.
 * 
 * @status development
 */
export const ActionBar: React.FC<Props> = ({ ariaLabel, isOpen, className, contentClassName, children }) => {
  return (
    <Dialog
      isOpen={isOpen}
      fullscreenOnMobile={false}
      ariaLabel={ariaLabel}
      className={classNames("action-bar", className)}
      contentClassName={contentClassName}
      hasOverlay={false}
      lockPageScroll={false}
      autoFocus={false}
    >
      {children}
    </Dialog>
  );
}
